import { render, staticRenderFns } from "./RoleShow.vue?vue&type=template&id=be3fe982"
import script from "./RoleShow.vue?vue&type=script&lang=js"
export * from "./RoleShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports